import React from 'react';
import { compose } from 'ramda';

import {  Button } from '@synergycms_core/components/generic';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './newAvailButton.js';
import { validateAsyncComponent } from '../../HoC';
import connect from 'react-redux/es/connect/connect';
import actions from '../../../store/actions';
import { Map } from 'immutable';
import moment from 'moment';


const NewAvailButton = class NewAvailButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  static displayName = 'NewAvailButton';

  render() {
    const { theme } = this.props;
    const { classes } = theme.styles;

    return (
      <div className={[theme.computedInnerStyle , classes.dateChangeButton].join(' ')}>
        <Button onClick={this.props.config.getNewAvailDay} innerStyle={'toggleMainButton'} ariaLabel={'_%cambiar fechas%_'} richText={{plural: true,text: '_%cambiar fechas%_',ucFirst: true,innerStyle: ['toggleMainButton'],translate: true}}>
        </Button>
      </div>
    );
  }
};



const mapDispatchToProps = dispatch => {
  return {
    getNewAvailDay: (baseDate, baseEnd, datepickerDates, room) => (e) => {
      const start = datepickerDates && datepickerDates.start;
      const end = datepickerDates && datepickerDates.end;
      if ((start && baseDate !== start) || (end && baseEnd !== end)) {

        dispatch(
          actions.customer.params.updateParams(
            Map({
              date: datepickerDates.start,
              stay_length: moment(datepickerDates.end).diff(moment(datepickerDates.start), 'd', true),
              room_id: ((room && room.get("id")) || null)
            })
          )
        );

        dispatch(actions.router.update(true));
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 300);
      }
    }
  };
};
const mapStateToProps = store => {
  const date = store.getIn(['customer', 'params', 'params', 'date']);
  const dateEnd = store.getIn(['customer', 'params', 'url_params', 'end']);
  return {
    date,
    dateEnd
  };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    getNewAvailDay: dispatchProps.getNewAvailDay(stateProps.date, stateProps.dateEnd, ownProps.dates, ownProps.room)
  });
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager(['getNewAvailDay', 'date', 'room', 'dates']),
  withThemeJSS({ styleFile, link: true })
)(NewAvailButton);
